// Every namespace of the website's fr text. Area translations add their keys to their own
// namespace file; see ../README.md.
import common from "./common.json";
import nav from "./nav.json";
import auth from "./auth.json";
import orders from "./orders.json";
import shipments from "./shipments.json";
import ship from "./ship.json";
import products from "./products.json";
import finances from "./finances.json";
import settings from "./settings.json";
import warehouse from "./warehouse.json";
import inventory from "./inventory.json";
import admin from "./admin.json";
import carrier from "./carrier.json";
import tickets from "./tickets.json";
import sales from "./sales.json";
import tracking from "./tracking.json";

const resources = {
  common,
  nav,
  auth,
  orders,
  shipments,
  ship,
  products,
  finances,
  settings,
  warehouse,
  inventory,
  admin,
  carrier,
  tickets,
  sales,
  tracking,
};

export default resources;
